export const GetBeamHeight = (in_beamType) => {
    let height = 65;
    if (in_beamType === "1086510") height = 108;
    if (in_beamType === "1586510") height = 158;
    if (in_beamType === "2086510") height = 208;
    if (in_beamType?.includes && in_beamType.includes("FL10011")) height = 100;
    if (in_beamType?.includes && in_beamType.includes("FL15015")) height = 150;
    if (in_beamType?.includes && in_beamType.includes("FL20020")) height = 200;
    if (in_beamType?.includes && in_beamType.startsWith("100mm x")) height = 108;
    if (in_beamType?.includes && in_beamType.startsWith("150mm x")) height = 108;
    return height;
};
